import React from 'react';

// import tile component variations
import ContentTile from 'components/tiles/content-tile/ContentTile';
import PeopleTile from 'components/tiles/people-tile/PeopleTile';

const renderItem =(item, itemType) => {
    // Determine which tile component gets rendered
    switch (itemType) {
        case 'people':
            return (
                <PeopleTile item={item} />
            );
        // add more below...
        default:
            return (
                <ContentTile item={item} />
            );
    }
};


const ListItem = ({ item, itemType }) => {
    return (
        renderItem(item, itemType)
    );
};

ListItem.propTypes = {
    item: React.PropTypes.object.isRequired,
    itemType: React.PropTypes.string.isRequired
};

export default ListItem;



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/items/listing-item/ListItem.jsx
 **/